/** @format */

import React from "react";
import { BsExclamationTriangle } from "react-icons/bs";

const FormError = ({ children }) => {
  return (
    <div className="error__message">
      <BsExclamationTriangle style={{ margin: "0 0.25rem 0 0" }} />
      {children}
    </div>
  );
};

export default FormError;
